import { useRef, useState } from "react";
import api, { formatErr } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Upload } from "lucide-react";

export default function ImportButton({ resource, onDone, label = "Import Excel", disabled }) {
  const ref = useRef(null);
  const [loading, setLoading] = useState(false);

  const upload = async (file) => {
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post(`/import/${resource}`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      toast.success(`Imported ${data.inserted} rows • skipped ${data.skipped}`);
      if (data.errors?.length) {
        toast.warning(`${data.errors.length} row(s) had issues`, { description: data.errors.slice(0, 3).join("\n") });
      }
      onDone && onDone();
    } catch (e) {
      toast.error(formatErr(e?.response?.data?.detail) || "Import failed");
    } finally {
      setLoading(false);
      if (ref.current) ref.current.value = "";
    }
  };

  return (
    <>
      <input
        ref={ref}
        type="file"
        accept=".xlsx,.xls"
        className="hidden"
        onChange={(e) => e.target.files?.[0] && upload(e.target.files[0])}
        data-testid={`${resource}-import-input`}
      />
      <Button
        type="button"
        disabled={disabled || loading}
        onClick={() => ref.current?.click()}
        className="h-9 bg-[#1EA0D2] hover:bg-[#1A88B0] text-white font-semibold"
        data-testid={`${resource}-import-btn`}
      >
        <Upload className="h-4 w-4 mr-1.5" /> {loading ? "Importing…" : label}
      </Button>
    </>
  );
}
